var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxboldclipboardEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#292D32;}\n\t.st2{display:none;fill-rule:evenodd;clip-rule:evenodd;fill:#292D32;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "vuesax_x2F_bold_x2F_clipboard-eye"
  }, /*#__PURE__*/React.createElement("g", {
    id: "clipboard-eye"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    className: "st1",
    d: "M9.7,2c-1,0-1.9,0.8-1.9,1.9v0.9c0,1,0.8,1.9,1.9,1.9h4.7c1,0,1.9-0.8,1.9-1.9V3.9 c0-1-0.8-1.9-1.9-1.9H9.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M11.3,16.7c-0.2,0.1-0.3,0.2-0.5,0.2s-0.4-0.1-0.5-0.2l-1.5-1.5c-0.3-0.3-0.3-0.8,0-1.1 c0.3-0.3,0.8-0.3,1.1,0l1,1l3.5-3.5c0.3-0.3,0.8-0.3,1.1,0c0.3,0.3,0.3,0.8,0,1.1L11.3,16.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.3,4.2c-0.5-0.3-1.1,0.1-1.1,0.7c0,1.6-1.3,2.9-2.9,2.9H9.6c-1.6,0-2.9-1.3-2.9-2.9 c0-0.6-0.6-0.9-1.1-0.7c-1.4,0.8-2.4,2.2-2.4,4v9.4c0,2.5,2,4.5,4.5,4.5h8.5c2.5,0,4.5-2,4.5-4.5V8.1C20.7,6.4,19.7,4.9,18.3,4.2 z M17.3,16.4c0,0-0.7,1.3-2.1,2.2c0,0-1.3,1-3.1,1s-3.1-1-3.1-1c-1.4-0.9-2.1-2.2-2.1-2.2c-1-1.6,0-3.1,0-3.1 c0.5-1.1,2.1-2.2,2.1-2.2s1.3-1,3.1-1c1.7,0,3.1,1,3.1,1s1.5,1,2.1,2.2C17.3,13.4,18.3,14.9,17.3,16.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.1,12.1c-1.6,0-2.8,1.3-2.8,2.8s1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8S13.6,12.1,12.1,12.1z M12.1,16.2 c-0.7,0-1.3-0.6-1.3-1.3s0.6-1.3,1.3-1.3s1.3,0.6,1.3,1.3S12.8,16.2,12.1,16.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_00000049190219440186848790000018432200231704715399_",
    className: "st0",
    d: "M0,24V0h24v24H0z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxboldclipboardEye);
export default __webpack_public_path__ + "static/media/vuesaxboldclipboard-eye.6c9fcd144ecc2da23703873d72643d92.svg";
export { ForwardRef as ReactComponent };